export const formatDateTimeForInput = (date) => {
  if (!date) return '';
  
  // Handle both Date objects and string dates
  const dateObj = date instanceof Date ? date : new Date(date);
  
  // Adjust for timezone offset
  const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
  const localDate = new Date(dateObj.getTime() - timezoneOffset);
  
  // Format the date to YYYY-MM-DDThh:mm
  return localDate.toISOString().slice(0, 16);
};

export const formatDateForInput = (date) => {
  if (!date) return '';
  
  // Handle both Date objects and string dates
  const dateObj = date instanceof Date ? date : new Date(date);
  
  // Adjust for timezone offset
  const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
  const localDate = new Date(dateObj.getTime() - timezoneOffset);
  
  // Format the date to YYYY-MM-DDThh:mm
  return localDate.toISOString().slice(0, 10);
};